<script>
/**
 * @Author: zhangxiaojian
 * @Date: 2025/8/14
 * @LastEditors: zhangxiaojian
 * @Description 无效链接组件
 **/
export default {
  name: 'Index',
  methods: {
    /**
     * 返回上一个链接地址
     */
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<template>
  <div class="is-route-empty">
    <div class="not-found">
      <img alt="404" class="not-found-bg" src="../../assets/img/404.png" />
      <p class="not-found-tip">抱歉，当前页面无法访问。</p>
      <p class="not-found-min-tip">
        网址错误或不存在。请检查网址或点击下方按钮返回
      </p>
      <span @click="back" class="not-found-back">返回</span>
    </div>
  </div>

</template>

<style scoped lang="scss">
.is-route-empty{
  position: absolute;
  width: 100%;
  height: 100%;
  left:0;
  top:0;
  z-index: 999;
  background: #fff;
}
.not-found {
  position: relative;
  max-width: 1920px;
  height: 500px;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  padding: 40px 5%;
  max-height: 80%;
  &-bg {
    position: absolute;
    right: 0;
    height: 100%;
  }
  &-tip {
    font-size: 28px;
    color: #454647;
    font-weight: bold;
  }
  &-min-tip {
    color: #737b80;
    font-size: 16px;
    margin-top: 20px;
  }
  &-back {
    color: #006bff;
    display: inline-block;
    width: 112px;
    text-align: center;
    line-height: 40px;
    border: 2px solid #006bff;
    border-radius: 20px;
    margin-top: 30px;
    cursor: pointer;
  }
}
</style>
